import type { ReactNode } from 'react';
import { BookOpen, Building2, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import './directory-section.css';

type DirectoryTab = 'companies' | 'contacts' | 'templates';

const TABS = [
  { id: 'companies' as const, label: 'Компании', path: '/companies', icon: Building2 },
  { id: 'contacts' as const, label: 'Контакты', path: '/contacts', icon: Users },
  { id: 'templates' as const, label: 'Шаблоны', path: '/templates', icon: BookOpen },
];

export function DirectorySection({ active, children }: { active: DirectoryTab; children: ReactNode }) {
  return <div className="directory-section-shell">
    <nav className="directory-section-navigation" aria-label="Разделы справочников">
      <div>
        <span className="directory-section-navigation__mark"><BookOpen /></span>
        <span><b>Справочники</b><small>Единая база данных портала</small></span>
      </div>
      <div className="directory-section-navigation__tabs">
        {TABS.map(tab => {
          const Icon = tab.icon;
          const current = tab.id === active;
          return <Link key={tab.id} to={tab.path} className={current ? 'active' : undefined} aria-current={current ? 'page' : undefined}>
            <Icon aria-hidden="true" /><span>{tab.label}</span>
          </Link>;
        })}
      </div>
    </nav>
    {children}
  </div>;
}
